import * as Yup from "yup";
import { useFormik } from "formik";
import React from "react";

import { Checkbox, FormControlLabel, FormGroup, FormHelperText } from "@mui/material";

import { createInitialValues } from "./MutipleOptionsPage";
import { QuestionaireBasePage } from "./QuestionaireBasePage";
import { Question, QuestionDefinitionDto } from "./questionaire-types";

type ConfirmationPageProps = {
  questionDefinition: QuestionDefinitionDto;
  onNext: (question: Question) => void;
  isSaving: boolean;
  isFrenchLanguage:boolean;
};

export const ConfirmationPage = (props: ConfirmationPageProps) => {
  const { questionDefinition, onNext, isSaving } = props;

  const validationObject: any = {};
  questionDefinition.options?.forEach((option) => {
    if (option.isMandatory) {
      validationObject[option.key] = !props.isFrenchLanguage?
      Yup.bool().isTrue("Please select the condition above"):
      Yup.bool().isTrue("Veuillez sélectionner la condition ci-dessus");
    }
  });

  const formik = useFormik({
    initialValues: createInitialValues(questionDefinition.options!),
    validationSchema: Yup.object().shape(validationObject),
    onSubmit: (value) => {
      const answers = Object.keys(value)
        .filter((k) => value[k] === true)
        .map((k) => {
          const option = questionDefinition.options!.find((o) => o.key === k)!;
          return {
            key: k,
            label: option.label,
          };
        });
      const question = {
        key: questionDefinition.key,
        label: questionDefinition.title,
        answers,
      };
      onNext(question);
    },
  });

  return (
    <QuestionaireBasePage questionDefinition={questionDefinition} formik={formik} isSaving={isSaving}  isFrenchLanguage={props.isFrenchLanguage}>
      <FormGroup sx={{ mt: 3 }}>
        {questionDefinition.options?.map((o) => (
          <div key={o.key}>
            <FormControlLabel label={o.label} name={o.key} onChange={formik.handleChange} control={<Checkbox value={formik.values[o.key]} />} />
            <FormHelperText error={formik.touched[o.key] && Boolean(formik.errors[o.key])}>{formik.touched[o.key] && formik.errors[o.key]}</FormHelperText>
          </div>
        ))}
      </FormGroup>
    </QuestionaireBasePage>
  );
};
